// extracted by mini-css-extract-plugin
module.exports = {"submenu":"Submenu_submenu__21LOK","submenuRight":"Submenu_submenuRight__qEIGS"};